"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _svg = _interopRequireDefault(require("@superlogica/superlogica-core/icons/pjBank/svg"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = _interopRequireDefault(require("@superlogica/superlogica-core/resources/color"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    height: 1em;\n    width: auto;\n    &.icon-left {\n      display: inline-block;\n      margin-right: ", ";\n    }\n    &.icon-right {\n      float: right;\n      margin-left: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    fill: ", ";\n    stroke: #000;\n    stroke-width: 0px;\n    width: auto;\n    height: 100%;\n    transition: 0.2s all linear;\n    vertical-align: -0.125em;\n    display: inline-block;\n    & g {\n      fill: ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Icon = function Icon(props) {
  var name = validateIcon(props.name);
  var color = _color.default[props.color] ? props.color : null;
  var viewBox = "0 0 ".concat(_svg.default[name].width, " ").concat(_svg.default[name].height);
  var type = validateType(props.type);
  var classes = validateClass(props.position, props.className);

  var Svg = _styledComponents.default.svg(_templateObject(), _color.default[color] || 'inherit', _color.default[color] || 'inherit');

  var Box = _styledComponents.default.div(_templateObject2(), function (_ref) {
    var theme = _ref.theme;
    return theme.margin.xxs;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.margin.xxs;
  });

  return /*#__PURE__*/_react.default.createElement(Box, {
    className: classes
  }, /*#__PURE__*/_react.default.createElement(Svg, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: _svg.default[name].id
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: _svg.default[name][type]
  }))));
};

var validateIcon = function validateIcon(icon) {
  var name = _svg.default[icon] ? icon : 'dontExist';

  if (name === 'dontExist') {
    console.error('Ops! Icone informado (' + icon + ') não existe!');
  }

  return name;
};

var validateClass = function validateClass(posit, classname) {
  var regexPosition = /^((left|right|center)|\s+)$/;
  var position = regexPosition.test(posit) ? posit : 'left';
  return "icon-".concat(position, " ").concat(classname || null);
};

var validateType = function validateType(data) {
  var regexType = /^((solid|light)\s+)$/;
  return regexType.test(data) ? data : 'solid';
};

Icon.propTypes = {
  className: _propTypes.default.string,
  name: _propTypes.default.string,
  color: _propTypes.default.string,
  position: _propTypes.default.string,
  type: _propTypes.default.string
};
var _default = Icon;
exports.default = _default;
